// Add this just after the existing imports in DownloadModal.jsx
export const residentialView = [
  { name: 'absenteeOwner' },
  { name: 'address' },
  { name: 'appliances' },
  { name: 'architecturalStyles' },
  { name: 'assessedValues' },
  { name: 'brokers' },
  { name: 'buildingName' },
  { name: 'categories' },
  { name: 'cbsaCode' },
  { name: 'cbsaName' },
  { name: 'censusBlock' },
  { name: 'censusBlockGroup' },
  { name: 'censusTract' },
  { name: 'city' },
  { name: 'civilDivisionCode' },
  { name: 'civilDivisionName' },
  { name: 'congressionalDistrictHouse' },
  { name: 'country' },
  { name: 'county' },
  { name: 'countyFIPS' },
  { name: 'currentOwnerType' },
  { name: 'dateAdded' },
  { name: 'dateUpdated' },
  { name: 'deposits' },
  { name: 'descriptions' },
  { name: 'estimatedPrices' },
  { name: 'exteriorConstruction' },
  { name: 'exteriorFeatures' },
  { name: 'features' },
  { name: 'fees' },
  { name: 'floorPlans' },
  { name: 'floorSizeValue' },
  { name: 'floorSizeUnit' },
  { name: 'geoLocation' },
  { name: 'hvacTypes' },
  { name: 'imageURLs' },
  { name: 'instrumentNumber' },
  { name: 'involuntaryLienJudgement' },
  { name: 'isUnit' },
  { name: 'keys' },
  { name: 'latitude' },
  { name: 'leasingTerms' },
  { name: 'legalDescription' },
  { name: 'legalRange' },
  { name: 'listingName' },
  { name: 'longitude' },
  { name: 'lotDepthValue' },
  { name: 'lotDepthUnit' },
  { name: 'lotSizeValue' },
  { name: 'lotSizeUnit' },
  { name: 'managedBy' },
  { name: 'mlsName' },
  { name: 'mlsNumber' },
  { name: 'mostRecentAbsenteeOwner' },
  { name: 'mostRecentAbsenteeOwnerFirstDateSeen' },
  { name: 'mostRecentBrokerAgent' },
  { name: 'mostRecentBrokerCompany' },
  { name: 'mostRecentBrokerDateSeen' },
  { name: 'mostRecentBrokerEmails' },
  { name: 'mostRecentBrokerPhones' },
  { name: 'mostRecentEstimatedPriceAmount' },
  { name: 'mostRecentEstimatedPriceDate' },
  { name: 'mostRecentEstimatedPriceDomain' },
  { name: 'mostRecentEstimatedPriceSourceURL' },
  { name: 'mostRecentInvoluntaryJudgement' },
  { name: 'mostRecentInvoluntaryLien' },
  { name: 'mostRecentInvoluntaryLienJudgementFirstDateSeen' },
  { name: 'mostRecentPriceCurrency' },
  { name: 'mostRecentPriceDomain' },
  { name: 'mostRecentRentalListPriceAmount' },
  { name: 'mostRecentRentalListPriceDate' },
  { name: 'mostRecentRentalPriceDomain' },
  { name: 'mostRecentRentalPriceFirstDateSeen' },
  { name: 'mostRecentRentalPricePeriod' },
  { name: 'mostRecentRentalPriceSourceURL' },
  { name: 'mostRecentSaleListPriceAmount' },
  { name: 'mostRecentSaleListPriceDate' },
  { name: 'mostRecentSoldPriceAmount' },
  { name: 'mostRecentSoldPriceDate' },
  { name: 'mostRecentStatus' },
  { name: 'mostRecentStatusDate' },
  { name: 'mostRecentStatusFirstDateSeen' },
  { name: 'mostRecentVacancy' },
  { name: 'mostRecentVacancyFirstDateSeen' },
  { name: 'msaCode' },
  { name: 'msaName' },
  { name: 'municipality' },
  { name: 'neighborhoods' },
  { name: 'numBathroom' },
  { name: 'numBedroom' },
  { name: 'numFloor' },
  { name: 'numParkingSpaces' },
  { name: 'numPeople' },
  { name: 'numRoom' },
  { name: 'numUnit' },
  { name: 'ownerOccupied' },
  { name: 'ownerOccupiedStatus' },
  { name: 'parking' },
  { name: 'parkingTypes' },
  { name: 'parcelNumbers' },
  { name: 'paymentTypes' },
  { name: 'people' },
  { name: 'permits' },
  { name: 'petPolicy' },
  { name: 'phones' },
  { name: 'postalCode' },
  { name: 'prices' },
  { name: 'propertyTaxes' },
  { name: 'propertyType' },
  { name: 'province' },
  { name: 'roofing' },
  { name: 'roomTypes' },
  { name: 'rules' },
  { name: 'sewerType' },
  { name: 'statuses' },
  { name: 'subdivision' },
  { name: 'taxExemptions' },
  { name: 'taxID' },
  { name: 'title' },
  { name: 'topographyCode' },
  { name: 'transactions' },
  { name: 'trustDescription' },
  { name: 'vacancy' },
  { name: 'websiteIDs' },
  { name: 'yearBuilt' },
  { name: 'zoning' }
];


export const commercialView = [
  { name: 'absenteeOwner' },
  { name: 'address' },
  { name: 'architecturalStyles' },
  { name: 'assessedValues' },
  { name: 'brokers' },
  { name: 'buildingName' },
  { name: 'capRate' },
  { name: 'categories' },
  { name: 'cbsaCode' },
  { name: 'cbsaName' },
  { name: 'censusBlock' },
  { name: 'censusBlockGroup' },
  { name: 'censusTract' },
  { name: 'city' },
  { name: 'civilDivisionCode' },
  { name: 'civilDivisionName' },
  { name: 'companies' },
  { name: 'congressionalDistrictHouse' },
  { name: 'country' },
  { name: 'county' },
  { name: 'countyFIPS' },
  { name: 'currentOwnerType' },
  { name: 'dateAdded' },
  { name: 'dateUpdated' },
  { name: 'deposits' },
  { name: 'descriptions' },
  { name: 'estimatedPrices' },
  { name: 'exteriorConstruction' },
  { name: 'exteriorFeatures' },
  { name: 'features' },
  { name: 'fees' },
  { name: 'floorPlans' },
  { name: 'floorSizeValue' },
  { name: 'floorSizeUnit' },
  { name: 'geoLocation' },
  { name: 'hvacTypes' },
  { name: 'imageURLs' },
  { name: 'instrumentNumber' },
  { name: 'investmentType' },
  { name: 'involuntaryLienJudgement' },
  { name: 'isUnit' },
  { name: 'keys' },
  { name: 'latitude' },
  { name: 'leasingTerms' },
  { name: 'legalDescription' },
  { name: 'legalRange' },
  { name: 'listingName' },
  { name: 'longitude' },
  { name: 'lotDepthValue' },
  { name: 'lotDepthUnit' },
  { name: 'lotSizeValue' },
  { name: 'lotSizeUnit' },
  { name: 'managedBy' },
  { name: 'mlsName' },
  { name: 'mlsNumber' },
  { name: 'mostRecentAbsenteeOwner' },
  { name: 'mostRecentAbsenteeOwnerFirstDateSeen' },
  { name: 'mostRecentBrokerAgent' },
  { name: 'mostRecentBrokerCompany' },
  { name: 'mostRecentBrokerDateSeen' },
  { name: 'mostRecentBrokerEmails' },
  { name: 'mostRecentBrokerPhones' },
  { name: 'mostRecentEstimatedPriceAmount' },
  { name: 'mostRecentEstimatedPriceDate' },
  { name: 'mostRecentEstimatedPriceDomain' },
  { name: 'mostRecentEstimatedPriceSourceURL' },
  { name: 'mostRecentInvoluntaryJudgement' },
  { name: 'mostRecentInvoluntaryLien' },
  { name: 'mostRecentInvoluntaryLienJudgementFirstDateSeen' },
  { name: 'mostRecentPriceCurrency' },
  { name: 'mostRecentPriceDomain' },
  { name: 'mostRecentRentalListPriceAmount' },
  { name: 'mostRecentRentalListPriceDate' },
  { name: 'mostRecentRentalPriceDomain' },
  { name: 'mostRecentRentalPriceFirstDateSeen' },
  { name: 'mostRecentRentalPricePeriod' },
  { name: 'mostRecentRentalPriceSourceURL' },
  { name: 'mostRecentSaleListPriceAmount' },
  { name: 'mostRecentSaleListPriceDate' },
  { name: 'mostRecentSoldPriceAmount' },
  { name: 'mostRecentSoldPriceDate' },
  { name: 'mostRecentStatus' },
  { name: 'mostRecentStatusDate' },
  { name: 'mostRecentStatusFirstDateSeen' },
  { name: 'mostRecentVacancy' },
  { name: 'mostRecentVacancyFirstDateSeen' },
  { name: 'msaCode' },
  { name: 'msaName' },
  { name: 'municipality' },
  { name: 'neighborhoods' },
  { name: 'netOperatingIncome' },
  { name: 'numFloor' },
  { name: 'numParkingSpaces' },
  { name: 'numPeople' },
  { name: 'numRoom' },
  { name: 'numUnit' },
  { name: 'ownerOccupied' },
  { name: 'ownerOccupiedStatus' },
  { name: 'parking' },
  { name: 'parkingTypes' },
  { name: 'parcelNumbers' },
  { name: 'paymentTypes' },
  { name: 'people' },
  { name: 'permits' },
  { name: 'phones' },
  { name: 'postalCode' },
  { name: 'prices' },
  { name: 'propertyTaxes' },
  { name: 'propertyType' },
  { name: 'province' },
  { name: 'roofing' },
  { name: 'roomTypes' },
  { name: 'rules' },
  { name: 'sewerType' },
  { name: 'statuses' },
  { name: 'subdivision' },
  { name: 'taxExemptions' },
  { name: 'taxID' },
  { name: 'title' },
  { name: 'topographyCode' },
  { name: 'transactions' },
  { name: 'trustDescription' },
  { name: 'vacancy' },
  { name: 'websiteIDs' },
  { name: 'yearBuilt' },
  { name: 'zoning' }
];

export const transactionsView = [
  { name: 'address' },
  { name: 'city' },
  { name: 'country' },
  { name: 'county' },
  { name: 'dateAdded' },
  { name: 'dateUpdated' },
  { name: 'geoLocation' },
  { name: 'keys' },
  { name: 'latitude' },
  { name: 'leasingTerms' },
  { name: 'legalDescription' },
  { name: 'longitude' },
  { name: 'mlsName' },
  { name: 'mlsNumber' },
  { name: 'mostRecentPriceCurrency' },
  { name: 'mostRecentSaleListPriceAmount' },
  { name: 'mostRecentSaleListPriceDate' },
  { name: 'mostRecentSoldPriceAmount' },
  { name: 'mostRecentSoldPriceDate' },
  { name: 'mostRecentStatus' },
  { name: 'mostRecentStatusDate' },
  { name: 'postalCode' },
  { name: 'prices' },
  { name: 'propertyType' },
  { name: 'province' },
  { name: 'taxID' },
  {
    name: 'transactions',
    flatten: true,
    sub_fields: [
      { name: 'saleDate' },
      { name: 'firstDateSeen' },
      { name: 'lastDateSeen' },
      { name: 'documentNumber' },
      { name: 'documentType' },
      { name: 'price' },
      { name: 'sellerFirstName' },
      { name: 'sellerMiddleName' },
      { name: 'sellerLastName' },
      { name: 'buyerFirstName' },
      { name: 'buyerMiddleName' },
      { name: 'buyerLastName' },
      { name: 'lenderName' },
      { name: 'loanType' },
      { name: 'loanAmount' },
      { name: 'mortgageTerm' },
      { name: 'interestType' },
      { name: 'parcelNumber' },
      { name: 'ownerType' },
      { name: 'contactOwnerMailAddressFull' },
      { name: 'transactionID' }
    ]
  },
  { name: 'yearBuilt' }
];